import React, { useState } from "react";
import Swal from "sweetalert2";

import axiosConfig from "../../axiosConfig";
import { swalSubmit } from "../../shared/swalSubmit";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { CardContent } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import AutoComplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import MaterialTable from "material-table";
import Edit from "@material-ui/icons/Edit";
import authgetUser from "../../services/auth.getUser";
import jwt_decode from "jwt-decode";
import Modal from "@material-ui/core/Modal";
import UserMap from "./UserMap";

import styles from "../../shared/dashboardStyle";
import { tableIcons } from "../../shared/TableIcons";
import Loading from "../Loading/loading";
import { calculateAge } from "../../shared/calculateAge";
import DeleteOutline from "@material-ui/icons/DeleteOutline";

import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import { AlertsTableMedium } from "../Alerts/Alerts";
import EndUserChartData from "../Charts/BiometricsChart/EndUserChartData";
import EcgChart from "../Charts/EcgChart/EcgChart";
import "../Forms/Forms.css";

const useStyles = makeStyles(styles);
const useUserFormStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  title: {
    minWidth: "25vh",
  },
}));
export default function EndUser(props) {
  const classes = useUserFormStyles();
  const classes2 = useStyles();

  const formik = props.formik;
  const addressFormik = props.addressFormik;
  const temporaryAddressFormik = props.temporaryAddressFormik;

  const getTheUser = authgetUser();
  const decodedToken = jwt_decode(getTheUser.accessToken);
  const roleDescription = decodedToken.role;
  const municipalityDesc = decodedToken.municipalityDescription;
  const municipalityId = decodedToken.municipalityID;

  if (props.loading === false && formik) {
    return (
      <div>
        <form className="Form">
          <Card>
            <CardHeader color="warning">
              <h1 className={classes2.cardTitleWhite}>Καρτέλα Ωφελούμενου</h1>
            </CardHeader>

            <CardBody>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography
                    style={{ display: "flex" }}
                    component="h1"
                    variant="h6"
                    align="left"
                  >
                    Γενικά Στοιχεία
                    {props.isEditEndUser ? (
                      <Tooltip title="Επεξεργασία">
                        <Button onClick={props.editMainInfo}>
                          <Edit />
                        </Button>
                      </Tooltip>
                    ) : null}
                  </Typography>
                  <Typography></Typography>
                  <Divider />
                </Grid>
                {props.isEditEndUser ? (
                  <Grid item xs={12} sm={4}>
                    <TextField
                      required
                      id="beneficiaryId"
                      name="beneficiaryId"
                      label="Κωδ. Ωφελούμενου"
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={props.beneficiaryId}
                      disabled={true}
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="lastname"
                    name="lastname"
                    label="Επώνυμο"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.lastname
                        ? props.endUserData.lastname
                        : formik.values.lastname
                    }
                   disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.lastname && formik.errors.lastname ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.lastname}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="firstname"
                    name="firstname"
                    label="Όνομα"
                    fullWidth
                    autoComplete="given-name"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.firstname
                        ? props.endUserData.firstname
                        : formik.values.firstname
                    }
                    disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.firstname && formik.errors.firstname ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.firstname}
                    </span>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="middlename"
                    name="middlename"
                    variant="outlined"
                    label="Πατρώνυμο"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.middlename
                        ? props.endUserData.middlename
                        : formik.values.middlename
                    }
                   disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.middlename && formik.errors.middlename ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.middlename}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="yearOfBirth"
                    variant="outlined"
                    name="yearOfBirth"
                    type="number"
                    label="Έτος Γέννησης"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.yearOfBirth
                        ? props.endUserData.yearOfBirth
                        : formik.values.yearOfBirth
                    }
                    disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.yearOfBirth && formik.errors.yearOfBirth ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.yearOfBirth}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="age"
                    name="age"
                    variant="outlined"
                    label="Ηλικία"
                    fullWidth
                    value={
                      props.endUserData?.yearOfBirth
                        ? calculateAge(props.endUserData.yearOfBirth)
                        : calculateAge(formik.values.yearOfBirth)
                    }
                    disabled={true}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl className={classes.formControl}>
                    <InputLabel
                      className={classes.title}
                      id="demo-simple-select-label"
                    >
                      Φύλο
                    </InputLabel>
                    <Select
                      labelId="genderId"
                      variant="outlined"
                      id="genderId"
                      name="genderId"
                      onChange={formik.handleChange}
                      onClick={(event) =>
                        props.clearSavedData(event.target.name)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      inputProps={{ "aria-label": "Without label" }}
                    disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                      value={
                        props.endUserData?.genderId
                          ? props.endUserData.genderId
                          : formik.values.genderId
                      }
                    >
                      <MenuItem value={1}>Άνδρας</MenuItem>
                      <MenuItem value={2}>Γυναίκα</MenuItem>
                    </Select>
                    {formik.touched.genderId && formik.errors.genderId ? (
                      <span style={{ color: "red" }}>
                        {formik.errors.genderId}
                      </span>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    component="h1"
                    variant="h6"
                    align="left"
                    style={{ marginTop: "16px" }}
                  >
                    Στοιχεία Επικοινωνίας
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="personOfContact"
                    variant="outlined"
                    name="personOfContact"
                    label="Πρόσωπο Επικοινωνίας"
                    placeholder="Ονοματεπώνυμο"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.personOfContact
                        ? props.endUserData.personOfContact
                        : formik.values.personOfContact
                    }
                   disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.personOfContact &&
                    formik.errors.personOfContact ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.personOfContact}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="telephone"
                    name="telephone"
                    label="Τηλέφωνο"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.telephone
                        ? props.endUserData.telephone
                        : formik.values.telephone
                    }
                  disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.telephone && formik.errors.telephone ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.telephone}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="mobile"
                    name="mobile"
                    label="Τηλέφωνο 2"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.mobile
                        ? props.endUserData.mobile
                        : formik.values.mobile
                    }
                    disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.mobile && formik.errors.mobile ? (
                    <span style={{ color: "red" }}>{formik.errors.mobile}</span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="email"
                    name="email"
                    label="Email"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.endUserData?.email
                        ? props.endUserData.email
                        : formik.values.email
                    }
                    disabled={
                      props.isEditEndUser && !props.isMainInfoDisabled
                    }
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <span style={{ color: "red" }}>{formik.errors.email}</span>
                  ) : null}
                </Grid>
                {props.isEditEndUser && props.isMainInfoDisabled === true ? (
                  <Grid item xs={12} sm={12}>
                    <Button
                      style={{ textAlign: "center", marginTop: "16px" }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                    >
                      ΑΠΟΘΗΚΕΥΣΗ
                    </Button>
                  </Grid>
                ) : null}

                <Grid item xs={12}>
                  <Typography
                    component="h1"
                    variant="h6"
                    align="left"
                    style={{ marginTop: "16px" }}
                  >
                    Κύρια Διεύθυνση
                    {props.isEditEndUser ? (
                      <Tooltip title="Επεξεργασία">
                        <Button onClick={props.editAddress}>
                          <Edit />
                        </Button>
                      </Tooltip>
                    ) : null}
                  </Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="street"
                    name="street"
                    label="Οδός"
                    variant="outlined"
                    fullWidth
                    onChange={
                      props.isEditEndUser
                        ? addressFormik.handleChange
                        : formik.handleChange
                    }
                    onBlur={
                      props.isEditEndUser
                        ? addressFormik.handleBlur
                        : formik.handleBlur
                    }
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.isEditEndUser
                        ? props.endUserData?.street
                          ? props.endUserData.street
                          : addressFormik.values.street
                        : props.endUserData?.street
                          ? props.endUserData.street
                          : formik.values.street
                    }
                    disabled={props.isEditEndUser && !props.isAddressDisabled}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {props.isEditEndUser ? (
                    addressFormik.touched.street &&
                      addressFormik.errors.street ? (
                      <span style={{ color: "red" }}>
                        {addressFormik.errors.street}
                      </span>
                    ) : null
                  ) : formik.touched.street && formik.errors.street ? (
                    <span style={{ color: "red" }}>{formik.errors.street}</span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="number"
                    name="number"
                    label="Αριθμός"
                    type="text"
                    variant="outlined"
                    fullWidth
                    disabled={props.isEditEndUser && !props.isAddressDisabled}
                    onChange={
                      props.isEditEndUser
                        ? addressFormik.handleChange
                        : formik.handleChange
                    }
                    onBlur={
                      props.isEditEndUser
                        ? addressFormik.handleBlur
                        : formik.handleBlur
                    }
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.isEditEndUser
                        ? props.endUserData?.number
                          ? props.endUserData.number
                          : addressFormik.values.number
                        : props.endUserData?.number
                          ? props.endUserData.number
                          : formik.values.number
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {props.isEditEndUser ? (
                    addressFormik.touched.number &&
                      addressFormik.errors.number ? (
                      <span style={{ color: "red" }}>
                        {addressFormik.errors.number}
                      </span>
                    ) : null
                  ) : formik.touched.number && formik.errors.number ? (
                    <span style={{ color: "red" }}>{formik.errors.number}</span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="floor"
                    name="floor"
                    label="Όροφος"
                    type="number"
                    variant="outlined"
                    fullWidth
                    disabled={props.isEditEndUser && !props.isAddressDisabled}
                    onChange={
                      props.isEditEndUser
                        ? addressFormik.handleChange
                        : formik.handleChange
                    }
                    onBlur={
                      props.isEditEndUser
                        ? addressFormik.handleBlur
                        : formik.handleBlur
                    }
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.isEditEndUser
                        ? props.endUserData?.floor
                          ? props.endUserData.floor
                          : addressFormik.values.floor
                        : props.endUserData?.floor
                          ? props.endUserData.floor
                          : formik.values.floor
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {props.isEditEndUser ? (
                    addressFormik.touched.floor &&
                      addressFormik.errors.floor ? (
                      <span style={{ color: "red" }}>
                        {addressFormik.errors.floor}
                      </span>
                    ) : null
                  ) : formik.touched.floor && formik.errors.floor ? (
                    <span style={{ color: "red" }}>{formik.errors.floor}</span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="area"
                    name="area"
                    label="Περιοχή"
                    type="text"
                    variant="outlined"
                    fullWidth
                    onChange={
                      props.isEditEndUser
                        ? addressFormik.handleChange
                        : formik.handleChange
                    }
                    onBlur={
                      props.isEditEndUser
                        ? addressFormik.handleBlur
                        : formik.handleBlur
                    }
                    disabled={props.isEditEndUser && !props.isAddressDisabled}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.isEditEndUser
                        ? props.endUserData?.area
                          ? props.endUserData.area
                          : addressFormik.values.area
                        : props.endUserData?.area
                          ? props.endUserData.area
                          : formik.values.area
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {props.isEditEndUser ? (
                    addressFormik.touched.area && addressFormik.errors.area ? (
                      <span style={{ color: "red" }}>
                        {addressFormik.errors.area}
                      </span>
                    ) : null
                  ) : formik.touched.area && formik.errors.area ? (
                    <span style={{ color: "red" }}>{formik.errors.area}</span>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    required
                    id="postalcode"
                    name="postalcode"
                    label="ΤΚ"
                    type="number"
                    variant="outlined"
                    fullWidth
                    onChange={
                      props.isEditEndUser
                        ? addressFormik.handleChange
                        : formik.handleChange
                    }
                    onBlur={
                      props.isEditEndUser
                        ? addressFormik.handleBlur
                        : formik.handleBlur
                    }
                    disabled={props.isEditEndUser && !props.isAddressDisabled}
                    onClick={(event) => props.clearSavedData(event.target.name)}
                    value={
                      props.isEditEndUser
                        ? props.endUserData?.postalcode
                          ? props.endUserData.postalcode
                          : addressFormik.values.postalcode
                        : props.endUserData?.postalcode
                          ? props.endUserData.postalcode
                          : formik.values.postalcode
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {props.isEditEndUser ? (
                    addressFormik.touched.postalcode &&
                      addressFormik.errors.postalcode ? (
                      <span style={{ color: "red" }}>
                        {addressFormik.errors.postalcode}
                      </span>
                    ) : null
                  ) : formik.touched.postalcode && formik.errors.postalcode ? (
                    <span style={{ color: "red" }}>
                      {formik.errors.postalcode}
                    </span>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <AutoComplete
                      id="municipalityId"
                      options={props.allMunicipalities || []}
                      getOptionLabel={(option) => option.description}
                      disabled={props.isEditEndUser && !props.isAddressDisabled}
                      value={
                        (props.allMunicipalities || []).find(
                          (m) =>
                            Number(m.id) ===
                            Number(
                              props.isEditEndUser
                                ? addressFormik.values.municipalityId
                                : formik.values.municipalityId
                            )
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        const targetFormik = props.isEditEndUser
                          ? addressFormik
                          : formik;
                        targetFormik.setFieldValue(
                          "municipalityId",
                          newValue ? Number(newValue.id) : 0
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Δήμος*"
                          variant="outlined"
                          disabled={props.isEditEndUser && !props.isAddressDisabled}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    />
                  </FormControl>
                  {props.isEditEndUser ? (
                    addressFormik.touched.municipalityId &&
                      addressFormik.errors.municipalityId ? (
                      <span style={{ color: "red" }}>
                        {addressFormik.errors.municipalityId}
                      </span>
                    ) : null
                  ) : formik.touched.municipalityId && formik.errors.municipalityId ? (
                    <span style={{ color: "red" }}>{formik.errors.municipalityId}</span>
                  ) : null}
                </Grid>

                {props.isEditEndUser && props.isAddressDisabled === true ? (
                  <Grid item xs={12} sm={12}>
                    {props.IsValidAddress ? (
                      <Button
                        style={{ textAlign: "center", marginTop: "16px" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          addressFormik.handleSubmit();
                        }}
                      >
                        ΑΠΟΘΗΚΕΥΣΗ
                      </Button>
                    ) : (
                      <Button
                        style={{ textAlign: "center", marginTop: "16px" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          props.checkAddress(props.isEditEndUser ? addressFormik.values.municipalityId : formik.values.municipalityId, false);
                        }}
                      >
                        ελεγχος διευθυνσης
                      </Button>
                    )}
                  </Grid>
                ) : null}
                {props.isAddEndUser ? (
                  <Grid item xs={12} sm={12}>
                    <Button
                      style={{ textAlign: "center", marginTop: "16px" }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        props.checkAddress(formik.values.municipalityId);
                      }}
                    >
                      ελεγχος διευθυνσης
                    </Button>
                  </Grid>
                ) : null}

                {props.isEditEndUser ? (
                  <Grid item xs={12}>
                    <MaterialTable
                      title="Συσκευές"
                      columns={[
                        { title: "Τύπος", field: "deviceDescription" },
                        { title: "IMEI", field: "imei" },
                      ]}
                      data={props.deviceState}
                      icons={tableIcons}
                      localization={{
                        body: {
                          emptyDataSourceMessage:
                            "Δεν υπάρχουν συσκευές για προβολή.",
                          addTooltip: "Προσθήκη",
                          deleteTooltip: "Αλλαγή Συσκευής",
                          editTooltip: "Επεξεργασία",
                        },
                        toolbar: {
                          searchTooltip: "Αναζήτηση",
                          searchPlaceholder: "Αναζήτηση",
                        },
                        header: {
                          actions: "Αντικατάσταση",
                        },
                        pagination: {
                          firstTooltip: "Πρώτη Σελίδα",
                          lastTooltip: "Τελευταία Σελίδα",
                          previousTooltip: "Προηγούμενη Σελίδα",
                          nextTooltip: "Επόμενη Σελίδα",
                          labelDisplayedRows: "{from}-{to} από {count}",
                          labelRowsSelect: "Εγγραφές ανά Σελίδα",
                        },
                      }}
                      actions={[
                        roleDescription === "Admin"
                          ? {
                            icon: () => <DeleteOutline />,
                            tooltip: "Αλλαγή Συσκευής",
                            onClick: (e, row) => {
                              new Promise((resolve) => {
                                props.setPreviousDeviceId(row.id);
                                setTimeout(() => {
                                  resolve();
                                  props.setIsOpen(true);
                                  props.setDeviceState((prevState) => {
                                    const data = [...prevState.data];
                                    data.splice(data.indexOf(row), 1);
                                    return { ...prevState, data };
                                  });
                                }, 600);
                              });
                            },
                          }
                          : null,
                      ]}
                    />
                  </Grid>
                ) : null}
                {props.isOpen && props.isEditEndUser ? (
                  <Grid container spacing={1}>
                    <Grid item xs={9} sm={9}>
                      <AutoComplete
                        noOptionsText={"Δεν υπάρχουν διαθέσιμες Συσκευές"}
                        onChange={(event, newValue) => {
                          if (newValue === null) {
                            props.setdeviceAutoComplete({});
                          } else {
                            props.setdeviceAutoComplete(newValue);
                          }
                        }}
                        options={props.devicesOptions}
                        getOptionLabel={(option) =>
                          "Τύπος:" +
                          option.deviceDescription +
                          " IMEI:" +
                          option.imei +
                          " IMSI:" +
                          option.imsi +
                          " MSISDN:" +
                          option.msisdn
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Συσκευή . . ."
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          Swal.fire({
                            title: "",
                            text: `Έχετε επιλέξει να αντικαταστήσετε τη συσκευή με ΙΜΕΙ ${props.previousDeviceId} του Ωφελούμενου με Κωδικό ${props.deviceAutoCompleteId}.Με την επιλογή νέας συσκευής θα πρέπει να οριστούν/επιβεβαιωθούν οι ρυθμίσεις της συσκευής.`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Ναι",
                            cancelButtonText: "Οχι",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire({
                                title: "",
                                text: `Θέλετε να αντιγραφούν οι Ρυθμίσεις της Συσκευής με ΙΜΕΙ ${props.previousDeviceId} στη Συσκευή με IMEI ${props.deviceAutoCompleteId} (ΑΝΤΙΓΡΑΦΗ ΡΥΘΜΙΣΕΩΝ) ή να παραμείνουν οι Αρχικές Ρυθμίσεις για την Συσκευή με IMEI ${props.deviceAutoCompleteId}`,
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "ΑΝΤΙΓΡΑΦΗ ΡΥΘΜΙΣΕΩΝ",
                                cancelButtonText: "ΑΡΧΙΚΕΣ ΡΥΘΜΙΣΕΙΣ",
                                allowOutsideClick: false,
                              }).then((result) => {
                                let value;
                                if (result.isConfirmed) {
                                  value = false;
                                } else value = true;
                                Swal.fire(swalSubmit).then((result) => {
                                  if (result.isConfirmed) {
                                    axiosConfig
                                      .post(
                                        `/Device/ReplaceDevice/${props.previousDeviceId}/${props.deviceAutoCompleteId}/${value}`
                                      )
                                      .then((response) => {
                                        if (response.status === 200) {
                                          props.setDeviceState((prevState) => {
                                            const data = [...prevState.data];
                                            data.push(props.deviceAutoComplete);
                                            props.setIsOpen(false);
                                            return { ...prevState, data };
                                          });
                                        }
                                      });
                                  }
                                });
                              });
                            }
                          });
                        }}
                      >
                        επιβεβαιωση συσκευης
                      </Button>
                    </Grid>
                  </Grid>
                ) : props.isAddEndUser ? (
                  <>
                    <Grid item xs={12}>
                      <Typography
                        component="h1"
                        variant="h6"
                        align="left"
                        style={{ marginTop: "16px" }}
                      >
                        Συσκευή
                      </Typography>
                      <Divider />
                    </Grid>
                    <Grid item xs={12}>
                      <AutoComplete
                        multiple
                        noOptionsText={"Δεν υπάρχουν διαθέσιμες Συσκευές"}
                        options={props.Devices}
                        onChange={(event, newValue) => {
                          formik.setFieldValue(
                            "devices",
                            (newValue || []).map((device) => device.id)
                          );
                        }}
                        value={props.Devices.filter((opt) =>
                          (props.formik.values.devices || []).includes(opt.id)
                        )}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        getOptionLabel={(option) =>
                          "Τύπος:" +
                          option.deviceDescription +
                          " IMEI:" +
                          option.imei +
                          " IMSI:" +
                          option.imsi +
                          " MSISDN:" +
                          option.msisdn
                        }
                        name="devices"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Συσκευή . . ."
                            variant="outlined"
                            name="devices"
                          />
                        )}
                      />
                      {formik.errors.devices ? (
                        <span style={{ color: "red" }}>
                          {formik.errors.devices}
                        </span>
                      ) : null}
                    </Grid>
                  </>
                ) : null}
                {props.isEditEndUser && props.deviceState?.length > 0 && (
                  <Grid item xs={12}>
                    <EcgChart deviceId={props.deviceState[0]?.id} beneficiaryId={props.beneficiaryId} />
                  </Grid>
                )}
                {props.isEditEndUser ? (
                  <Grid container>
                    <Grid item sm={12}>
                      <Typography
                        component="h1"
                        variant="h6"
                        align="left"
                        style={{ marginTop: "16px" }}
                      >
                        Στατιστικά Βιομετρικών Ενδείξεων
                      </Typography>
                      <Divider />
                    </Grid>
                    <Divider />
                    <Grid item sm={4} style={{ marginTop: "10px" }}>
                      <FormControl className={classes.formControl}>
                        <InputLabel
                          className={classes.title}
                          id="select-biometric"
                        >
                          Επιλέξτε ημέρες Βιομετρικών
                        </InputLabel>
                        <Select
                          labelId="dateId"
                          variant="outlined"
                          id="dateId"
                          name="dateId"
                          onChange={props.handleChangeBiometricsDateId}
                          displayEmpty
                          className={classes.selectEmpty}
                          inputProps={{ "aria-label": "Without label" }}
                          value={props.biometricsDateId}
                        >
                          <MenuItem value={1}>Ημερήσια</MenuItem>
                          <MenuItem value={7}>Εβδομαδιαία</MenuItem>
                          <MenuItem value={-1}>Μηνιαία</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item sm={12}>
                      <CardContent style={{ height: 600, position: "left" }}>
                        <EndUserChartData
                          beneficiaryChartData={props.beneficiaryChartData}
                        />
                      </CardContent>
                    </Grid>
                  </Grid>
                ) : null}
                {props.isEditEndUser ? (
                  <>
                    <Grid item xs={12}>
                      <Typography
                        component="h1"
                        variant="h6"
                        align="left"
                        style={{ marginTop: "16px" }}
                      >
                        Ιστορικό Ειδοποιήσεων
                      </Typography>
                      <Divider />
                    </Grid>
                    <Grid item sm={4} style={{ marginTop: "10px" }}>
                      <FormControl className={classes.formControl}>
                        <InputLabel className={classes.title} id="select-stats">
                          Επιλέξτε ημέρες Στατιστικών
                        </InputLabel>
                        <Select
                          labelId="dateId"
                          variant="outlined"
                          id="dateId"
                          name="dateId"
                          onChange={props.handleChangeAlarmsDateId}
                          displayEmpty
                          className={classes.selectEmpty}
                          inputProps={{ "aria-label": "Without label" }}
                          value={props.alarmsDateId}
                        >
                          <MenuItem value={1}>Ημερήσια</MenuItem>
                          <MenuItem value={7}>Εβδομαδιαία</MenuItem>
                          <MenuItem value={-1}>Μηνιαία</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <AlertsTableMedium alarms={props.beneficiaryAlarms} />
                    </Grid>
                    <Grid
                      item
                      sm={12}
                      style={{ textAlign: "center", marginTop: "16px" }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          props.isDeviceEmpty();
                        }}
                      >
                        Συνεχεια
                      </Button>
                    </Grid>
                  </>
                ) : props.isAddEndUser ? (
                  <Grid
                    item
                    sm={12}
                    style={{ textAlign: "center", marginTop: "16px" }}
                  >
                    <Button
                      isplay={"block"}
                      variant="contained"
                      color="primary"
                      disabled={!props.IsValidAddress}
                      onClick={() => {
                        props.setCheckFormikErrors(true);
                        formik.handleSubmit();
                      }}
                    >
                      Συνεχεια
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
              <Modal
                open={props.openMap}
                onClose={() => props.setOpenMap(false)}
                disableBackdropClick
              >
                <UserMap
                  setIsValidAddress={props.setIsValidAddress}
                  setOpenMap={props.setOpenMap}
                  latitude={formik.values.latitude}
                  longitude={formik.values.longitude}
                />
              </Modal>
            </CardBody>
          </Card>
        </form>
      </div>
    );
  } else {
    return <Loading></Loading>;
  }
}
